import { DynamicRulesConfig, HeaderOperation, ResourceType, RuleActionType } from './BrowserExtension.types';

export const interceptRules = [
  {
    urls: ['https://www.linkedin.com/*'],
    headers: ['csrf-token', 'cookie', 'x-restli-protocol-version', 'x-li-lang', 'x-li-page-instance', 'x-li-track'],
    key: 'linkedInClassic',
  },
  {
    urls: [
      '*://cockpit.werktalent.com/*',
      '*://cockpit.getwork.nl/*',
      '*://cockpit.inaxtion.com/*',
      '*://resumes.indeed.com/*',
      '*://*.recruitnowcockpit.nl/*',
      '*://*.carerix.net/*',
      '*://*.otysapp.com/*',
      '*://*.umanga.nl/*',
      '*://*.lightning.force.com/*',
      '*://*.tellent.dev/*',
      '*://*.tellent.com/*',
      '*://*.bullhornstaffing.com/*',
    ],
    headers: ['authorization', 'csrf-token', 'cookie'],
    key: 'domainHeaders',
  },
];

export const pageInstanceMapping = {
  urlContains: 'linkedin',
  mappings: {
    'voyager/api/relationships/invitationsSummary': 'urn:li:page:d_flagship3_background;',
    'talent/api/talentContractOptions': 'urn:li:page:d_talent_contract_chooser;',
    'voyager/api/relationships/myNetworkNotifications': 'urn:li:page:d_flagship3_background;',
    'talent/search/api/talentRecruiterFacets': 'urn:li:page:d_talent_recruiter_search;',
    'voyager/api/voyagerMessagingDashComposeOptions': 'urn:li:page:d_flagship3_feed;',
    'voyager/api/voyagerMessagingGraphQL': 'urn:li:page:d_flagship3_feed;',
    'talent/api/graphql': 'urn:li:page:d_talent_inbox_folder_index;',
    'talent/api/talentMailboxSummary': 'urn:li:page:d_talent_home;',
    'voyager/api/graphql': 'urn:li:page:d_flagship3_feed;',
    'talent/api/talentMessageComposeInfo': 'urn:li:page:d_talent_account_settings_my_permissions;',
    'talent/api/talentRecruitingProfiles': 'urn:li:page:d_talent_inbox_folder_index;',
    'talent/api/talentMessagePosts': 'urn:li:page:d_talent_inbox_folder_index;',
    'voyager/api/voyagerRelationshipsDashMemberRelationships': 'urn:li:page:d_flagship3_feed;',
    'voyager/api/voyagerMessagingDashMessengerMessages': 'urn:li:page:d_flagship3_feed;',
  },
  headerKey: 'x-li-page-instance',
};

export const getDynamicRulesConfig = (userPlatform: string, userBrands: string): DynamicRulesConfig => ({
  removeRuleIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 99],
  addRules: [
    {
      id: 1,
      priority: 1,
      action: {
        type: RuleActionType.MODIFY_HEADERS,
        requestHeaders: [
          {
            header: 'Referer',
            operation: HeaderOperation.SET,
            value: 'https://resumes.indeed.com/',
          },
        ],
      },
      condition: {
        urlFilter: 'https://apis.indeed.com/graphql*',
        resourceTypes: [ResourceType.XMLHTTPREQUEST, ResourceType.MAIN_FRAME, ResourceType.SUB_FRAME],
      },
    },
    {
      id: 2,
      priority: 1,
      action: {
        type: RuleActionType.MODIFY_HEADERS,
        requestHeaders: [
          {
            header: 'Referer',
            operation: HeaderOperation.SET,
            value: 'https://www.linkedin.com/talent/contract-chooser?trk=nav_account_sub_nav_cap&',
          },
        ],
      },
      condition: {
        urlFilter: 'https://www.linkedin.com/talent/api/talentContractOptions*',
        resourceTypes: [ResourceType.XMLHTTPREQUEST, ResourceType.MAIN_FRAME, ResourceType.SUB_FRAME],
      },
    },
    {
      id: 3,
      priority: 1,
      action: {
        type: RuleActionType.MODIFY_HEADERS,
        requestHeaders: [
          {
            header: 'Referer',
            operation: HeaderOperation.SET,
            value: 'https://www.linkedin.com/talent/home',
          },
        ],
      },
      condition: {
        urlFilter: 'https://www.linkedin.com/talent/api/talentPageContent/account_overview_highlight',
        resourceTypes: [ResourceType.XMLHTTPREQUEST, ResourceType.MAIN_FRAME, ResourceType.SUB_FRAME],
      },
    },
    {
      id: 4,
      priority: 1,
      action: {
        type: RuleActionType.MODIFY_HEADERS,
        requestHeaders: [
          {
            header: 'Referer',
            operation: HeaderOperation.SET,
            value: 'https://www.linkedin.com/talent/search',
          },
        ],
      },
      condition: {
        urlFilter: 'https://www.linkedin.com/talent/search/api/talentRecruiterFacets*',
        resourceTypes: [ResourceType.XMLHTTPREQUEST, ResourceType.MAIN_FRAME, ResourceType.SUB_FRAME],
      },
    },
    {
      id: 5,
      priority: 1,
      action: {
        type: RuleActionType.MODIFY_HEADERS,
        requestHeaders: [
          {
            header: 'Referer',
            operation: HeaderOperation.SET,
            value: 'https://www.linkedin.com/talent/search',
          },
        ],
      },
      condition: {
        urlFilter: 'https://www.linkedin.com/talent/search/api/talentRecruiterSearchHits*',
        resourceTypes: [ResourceType.XMLHTTPREQUEST, ResourceType.MAIN_FRAME, ResourceType.SUB_FRAME],
      },
    },
    {
      id: 6,
      priority: 1,
      action: {
        type: RuleActionType.MODIFY_HEADERS,
        requestHeaders: [
          {
            header: 'Referer',
            operation: HeaderOperation.SET,
            value: 'https://www.linkedin.com/feed',
          },
          {
            header: 'sec-ch-prefers-color-scheme',
            operation: HeaderOperation.SET,
            value: 'light',
          },
        ],
      },
      condition: {
        urlFilter: 'https://www.linkedin.com/voyager/api/relationships/*',
        resourceTypes: [ResourceType.XMLHTTPREQUEST, ResourceType.MAIN_FRAME, ResourceType.SUB_FRAME],
      },
    },
    {
      id: 7,
      priority: 1,
      action: {
        type: RuleActionType.MODIFY_HEADERS,
        requestHeaders: [
          {
            header: 'Referer',
            operation: HeaderOperation.SET,
            value: 'https://www.linkedin.com/talent/inbox/0',
          },
        ],
      },
      condition: {
        urlFilter: 'https://www.linkedin.com/talent/api/graphql*',
        resourceTypes: [ResourceType.XMLHTTPREQUEST, ResourceType.MAIN_FRAME, ResourceType.SUB_FRAME],
      },
    },
    {
      id: 8,
      priority: 1,
      action: {
        type: RuleActionType.MODIFY_HEADERS,
        requestHeaders: [
          {
            header: 'Referer',
            operation: HeaderOperation.SET,
            value: 'https://www.linkedin.com/feed',
          },
          {
            header: 'sec-ch-prefers-color-scheme',
            operation: HeaderOperation.SET,
            value: 'light',
          },
        ],
      },
      condition: {
        urlFilter: 'https://www.linkedin.com/voyager/api/voyagerMessagingDashComposeOptions/*',
        resourceTypes: [ResourceType.XMLHTTPREQUEST, ResourceType.MAIN_FRAME, ResourceType.SUB_FRAME],
      },
    },
    {
      id: 9,
      priority: 1,
      action: {
        type: RuleActionType.MODIFY_HEADERS,
        requestHeaders: [
          {
            header: 'Referer',
            operation: HeaderOperation.SET,
            value: 'https://www.linkedin.com/feed',
          },
          {
            header: 'sec-ch-prefers-color-scheme',
            operation: HeaderOperation.SET,
            value: 'light',
          },
        ],
      },
      condition: {
        urlFilter: 'https://www.linkedin.com/voyager/api/voyagerMessagingGraphQL/graphql*',
        resourceTypes: [ResourceType.XMLHTTPREQUEST, ResourceType.MAIN_FRAME, ResourceType.SUB_FRAME],
      },
    },
    {
      id: 10,
      priority: 1,
      action: {
        type: RuleActionType.MODIFY_HEADERS,
        requestHeaders: [
          {
            header: 'Referer',
            operation: HeaderOperation.SET,
            value: 'https://www.linkedin.com/talent/home',
          },
        ],
      },
      condition: {
        urlFilter: 'https://www.linkedin.com/talent/api/talentMailboxSummary*',
        resourceTypes: [ResourceType.XMLHTTPREQUEST, ResourceType.MAIN_FRAME, ResourceType.SUB_FRAME],
      },
    },
    {
      id: 11,
      priority: 1,
      action: {
        type: RuleActionType.MODIFY_HEADERS,
        requestHeaders: [
          {
            header: 'Referer',
            operation: HeaderOperation.SET,
            value: 'https://www.linkedin.com/feed',
          },
          {
            header: 'sec-ch-prefers-color-scheme',
            operation: HeaderOperation.SET,
            value: 'light',
          },
        ],
      },
      condition: {
        urlFilter: 'https://www.linkedin.com/voyager/api/graphql*',
        resourceTypes: [ResourceType.XMLHTTPREQUEST, ResourceType.MAIN_FRAME, ResourceType.SUB_FRAME],
      },
    },
    {
      id: 12,
      priority: 1,
      action: {
        type: RuleActionType.MODIFY_HEADERS,
        requestHeaders: [
          {
            header: 'Referer',
            operation: HeaderOperation.SET,
            value: 'https://www.linkedin.com/talent/account/v2/my-permissions',
          },
        ],
      },
      condition: {
        urlFilter: 'https://www.linkedin.com/talent/api/talentMessageComposeInfo*',
        resourceTypes: [ResourceType.XMLHTTPREQUEST, ResourceType.MAIN_FRAME, ResourceType.SUB_FRAME],
      },
    },
    {
      id: 13,
      priority: 1,
      action: {
        type: RuleActionType.MODIFY_HEADERS,
        requestHeaders: [
          {
            header: 'Referer',
            operation: HeaderOperation.SET,
            value: 'https://www.linkedin.com/feed',
          },
          {
            header: 'sec-ch-prefers-color-scheme',
            operation: HeaderOperation.SET,
            value: 'light',
          },
          {
            header: 'origin',
            operation: HeaderOperation.SET,
            value: 'https://www.linkedin.com',
          },
        ],
      },
      condition: {
        urlFilter: 'https://www.linkedin.com/voyager/api/voyagerRelationshipsDashMemberRelationships*',
        resourceTypes: [ResourceType.XMLHTTPREQUEST, ResourceType.MAIN_FRAME, ResourceType.SUB_FRAME],
      },
    },
    {
      id: 14,
      priority: 1,
      action: {
        type: RuleActionType.MODIFY_HEADERS,
        requestHeaders: [
          {
            header: 'Referer',
            operation: HeaderOperation.SET,
            value: 'https://www.linkedin.com/feed',
          },
          {
            header: 'sec-ch-prefers-color-scheme',
            operation: HeaderOperation.SET,
            value: 'light',
          },
          {
            header: 'origin',
            operation: HeaderOperation.SET,
            value: 'https://www.linkedin.com',
          },
        ],
      },
      condition: {
        urlFilter: 'https://www.linkedin.com/voyager/api/voyagerMessagingDashMessengerMessages*',
        resourceTypes: [ResourceType.XMLHTTPREQUEST, ResourceType.MAIN_FRAME, ResourceType.SUB_FRAME],
      },
    },
    {
      id: 15,
      priority: 1,
      action: {
        type: RuleActionType.MODIFY_HEADERS,
        requestHeaders: [
          {
            header: 'Referer',
            operation: HeaderOperation.SET,
            value: 'https://www.linkedin.com/talent/inbox/0',
          },
        ],
      },
      condition: {
        urlFilter: 'https://www.linkedin.com/talent/api/talentRecruitingProfiles*',
        resourceTypes: [ResourceType.XMLHTTPREQUEST, ResourceType.MAIN_FRAME, ResourceType.SUB_FRAME],
      },
    },
    {
      id: 16,
      priority: 1,
      action: {
        type: RuleActionType.MODIFY_HEADERS,
        requestHeaders: [
          {
            header: 'Referer',
            operation: HeaderOperation.SET,
            value: 'https://www.linkedin.com/talent/inbox/0',
          },
          {
            header: 'origin',
            operation: HeaderOperation.SET,
            value: 'https://www.linkedin.com',
          },
        ],
      },
      condition: {
        urlFilter: 'https://www.linkedin.com/talent/api/talentMessagePosts*',
        resourceTypes: [ResourceType.XMLHTTPREQUEST, ResourceType.MAIN_FRAME, ResourceType.SUB_FRAME],
      },
    },
    {
      id: 99,
      priority: 1,
      action: {
        type: RuleActionType.MODIFY_HEADERS,
        requestHeaders: [
          {
            header: 'sec-ch-ua-platform',
            operation: HeaderOperation.SET,
            value: userPlatform,
          },
          {
            header: 'sec-ch-ua',
            operation: HeaderOperation.SET,
            value: userBrands,
          },
          {
            header: 'sec-fetch-dest',
            operation: HeaderOperation.SET,
            value: 'empty',
          },
          {
            header: 'sec-fetch-mode',
            operation: HeaderOperation.SET,
            value: 'cors',
          },
          {
            header: 'sec-fetch-site',
            operation: HeaderOperation.SET,
            value: 'same-origin',
          },
          {
            header: 'sec-ch-ua-mobile',
            operation: HeaderOperation.SET,
            value: '?0',
          },
          {
            header: 'priority',
            operation: HeaderOperation.SET,
            value: 'u=1, i',
          },
        ],
      },
      condition: {
        urlFilter: 'https://www.linkedin.com/*',
        resourceTypes: [ResourceType.XMLHTTPREQUEST, ResourceType.SUB_FRAME, ResourceType.MAIN_FRAME],
      },
    },
  ],
});
